import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "../src/css/style.bundle.rtl.css";
import "../src/css/common.css";
import "./features/store-language/direction.css";
import "./features/store-language/digitTypography.css";
import {
  applyDesigningHeaderTheme,
  loadDesigningHeaderTheme,
} from "./utils/designingHeaderTheme.ts";
import { registerServiceWorker } from "./utils/serviceWorkerRegistration.ts";

applyDesigningHeaderTheme(loadDesigningHeaderTheme(), false);

const hideInitialLoader = () => {
  document.getElementById("initial-loader")?.remove();
  document.body.classList.remove("page-loading");
  document.getElementById("kt_body")?.classList.remove("page-loading");
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

hideInitialLoader();

registerServiceWorker();
